import React from 'react';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import s from './ContentByUser.scss';
var ContentByUser = function (_a) {
    var contentUrl = _a.contentUrl, biData = _a.biData, contentTitle = _a.contentTitle;
    return (React.createElement(BiLink, { className: s['root'], href: contentUrl, biData: biData }, contentTitle));
};
ContentByUser.displayName = 'ContentByUser';
export default ContentByUser;
//# sourceMappingURL=ContentByUser.js.map